import { normalizeParamsObject } from 'shared-lib/helpers/formatters';
import localConfig from '@/config';

const types = {
    SAVE_FILTERS: 'SAVE_ACTIVITY_LOG_FILTERS',
    RESET_FILTERS: 'RESET_ACTIVITY_LOG_FILTERS',
};

const initialState = {
    data: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
};

const state = {
    ...initialState,
};


const getters = {
    activityLogFilters: state => state.data.filters,
};


const actions = {
    saveActivityLogFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetActivityLogFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },
    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
